<template>
  <div>
    <vxe-grid
      ref="skuTable"
      size="mini"
      resizable
      auto-resize
      show-footer-overflow
      :row-class-name="rowClassName"
      :cell-class-name="cellClassName"
      :columns="tableColumns"
      :loading="loading"
      :max-height="maxHeight"
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :edit-config="{
        enabled: !disabled,
        activeMethod: ({ row }) => !!row.amzPurchaseNo,
        trigger: 'click',
        mode: 'row',
      }"
      :edit-rules="editRules"
      @edit-closed="editClosed"
    >
      <template v-slot:toolbar_form>
        <slot name="header" />
      </template>
      <template v-slot:displayScm="{ row }">
        <div style="padding-right: 10px;">
          <el-descriptions :column="1" size="mini">
            <el-descriptions-item :label="'NC'">
              {{ row.ncNo }}
            </el-descriptions-item>
            <el-descriptions-item :label="'工厂'">
              {{ row.scmName }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="'仓库'"
              labelClassName="edit-descriptions-item"
              v-if="row.amzPurchaseCode && row.ecomWarehouseCode === 'FTYWH'"
            >
              <el-input
                v-model="row.displayEcomWarehouseName"
                size="mini"
                readonly
              />
            </el-descriptions-item>
            <el-descriptions-item :label="'仓库'" v-else>
              {{ row.displayEcomWarehouseName }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </template>
      <template v-slot:editScm="{ row }">
        <div style="padding-right: 10px;">
          <el-descriptions :column="1" size="mini">
            <el-descriptions-item :label="'NC'">
              {{ row.ncNo }}
            </el-descriptions-item>
            <el-descriptions-item :label="'工厂'">
              {{ row.scmName }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="'仓库'"
              labelClassName="edit-descriptions-item"
              v-if="row.amzPurchaseCode && row.ecomWarehouseCode === 'FTYWH'"
            >
              <dict-select
                v-model="row.displayEcomWarehouseCode"
                url="/ecom/warehouse/cn/warehouse/select"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                :selectedLabel.sync="row.displayEcomWarehouseName"
                filterable
                clearable
                size="mini"
              />
            </el-descriptions-item>
            <el-descriptions-item :label="'仓库'" v-else>
              {{ row.displayEcomWarehouseName }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </template>
      <template v-slot:displayFactory="{ row }">
        <el-descriptions :column="1" size="mini" v-if="row.amzPurchaseCode">
          <el-descriptions-item
            :label="$l('table_label_invoiceFactory') || '开票'"
            labelClassName="edit-descriptions-item"
          >
            <el-input v-model="row.invoiceFactoryName" size="mini" readonly />
          </el-descriptions-item>
          <!-- <el-descriptions-item
            :label="$l('table_label_shippingFactory') || '送货'"
            labelClassName="edit-descriptions-item"
          >
            <el-input v-model="row.shippingFactoryName" size="mini" readonly />
          </el-descriptions-item> -->
          <el-descriptions-item
            :label="$l('table_label_factoryDate') || '产装'"
            labelClassName="edit-descriptions-item"
          >
            <el-input v-model="row.factoryDate" size="mini" readonly />
          </el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-slot:editFactory="{ row }">
        <el-descriptions :column="1" size="mini" v-if="row.amzPurchaseCode">
          <el-descriptions-item
            :label="$l('table_label_invoiceFactory') || '开票'"
            labelClassName="edit-descriptions-item"
          >
            <dict-select
              v-model="row.invoiceFactoryCode"
              url="/master/common/dict/scmPartners"
              :selectedLabel.sync="row.invoiceFactoryName"
              filterable
              clearable
              size="mini"
            />
          </el-descriptions-item>
          <!-- <el-descriptions-item
            :label="$l('table_label_shippingFactory') || '送货'"
            labelClassName="edit-descriptions-item"
          >
            <dict-select
              v-model="row.shippingFactoryCode"
              url="/master/common/dict/scmPartners"
              :selectedLabel.sync="row.shippingFactoryName"
              filterable
              clearable
              size="mini"
            />
          </el-descriptions-item> -->
          <el-descriptions-item
            :label="$l('table_label_factoryDate') || '产装'"
            labelClassName="edit-descriptions-item"
          >
            <el-date-picker
              v-model="row.factoryDate"
              type="date"
              size="mini"
              value-format="yyyy-MM-dd"
              placeholder="Please select"
              style="width:100%"
            />
          </el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-slot:displayOrder="{ row }">
        <el-descriptions :column="1" size="mini" v-if="row.amzPurchaseCode">
          <el-descriptions-item
            :label="$l('table_label_purchaseDate') || '下单日'"
          >
            {{ row.deliveryDate }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('table_label_amzPurchaseNo') || '订单号'"
          >
            {{ row.amzPurchaseNo }}
          </el-descriptions-item>
          <el-descriptions-item :label="$l('table_label_ftyPrice') || '采购价'">
            {{ row.ftyPrice }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('table_label_remark') || '备注'"
            contentClassName="text-truncate"
          >
            <tooltip-text :content="row.remark" />
          </el-descriptions-item>
        </el-descriptions>

        <el-descriptions :column="1" size="mini" v-else>
          <el-descriptions-item>
            <el-tag size="mini" type="danger">
              {{ $l('table_label_noOrder') || '无订单' }}
            </el-tag>
          </el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-slot:displayReplyPropose="{ row }">
        <el-descriptions :column="1" size="mini">
          <el-descriptions-item
            :label="$l('table_label_maxReplyQty') || '可用'"
          >
            {{ row.maxReplyQty }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('table_label_proposeReplyQty') || '建议'"
          >
            {{ row.proposeReplyQty }}
          </el-descriptions-item>
        </el-descriptions>
        <div v-if="row.amzPurchaseCode">
          <el-tag
            v-if="row.ecomWarehouseCode === 'FTYWH'"
            size="mini"
            type="warning"
          >
            {{ $l('table_label_orderShipping') || '订单出货' }}
          </el-tag>
          <el-tag size="mini" type="success" v-else>
            {{ $l('table_label_whShipping') || '仓库出货' }}
          </el-tag>
        </div>
      </template>
      <template v-slot:displayReplyQty="{ row }">
        <el-descriptions :column="1" size="mini">
          <el-descriptions-item
            v-if="row.amzPurchaseCode"
            :label="$l('table_label_qty') || '返答'"
            labelClassName="edit-descriptions-item"
          >
            <el-input v-model="row.qty" size="mini" readonly />
          </el-descriptions-item>
          <el-descriptions-item :label="$l('table_label_inCtnQty') || '入数'">
            {{ row.inCtnQty }}
          </el-descriptions-item>
          <!-- <el-descriptions-item
            v-if="row.tailQty"
            :label="$l('table_label_tailQty') || '尾数'"
            :contentStyle="{ color: 'red' }"
          >
            {{ row.tailQty }}
          </el-descriptions-item> -->
        </el-descriptions>
      </template>
      <template v-slot:replyQty="{ row }">
        <el-descriptions :column="1" size="mini">
          <el-descriptions-item
            v-if="row.amzPurchaseCode"
            :label="$l('table_label_qty') || '返答'"
            labelClassName="edit-descriptions-item"
          >
            <el-input-number
              v-model="row.qty"
              :controls="false"
              :precision="0"
              :min="0"
              :max="row.maxReplyQty"
              clearable
              size="mini"
              style="width:100%;"
            />
          </el-descriptions-item>
          <el-descriptions-item :label="$l('table_label_inCtnQty') || '入数'">
            {{ row.inCtnQty }}
          </el-descriptions-item>
          <!-- <el-descriptions-item
            v-if="row.tailQty"
            :label="$l('table_label_tailQty') || '尾数'"
            :contentStyle="{ color: 'red' }"
          >
            {{ row.tailQty }}
          </el-descriptions-item> -->
        </el-descriptions>
      </template>
      <template v-slot:displayCtnQty="{ row }">
        <el-descriptions :column="1" size="mini" v-if="row.amzPurchaseCode">
          <el-descriptions-item :label="$l('table_label_ctnQty') || '整箱'">
            {{ row.ctnQty }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('table_label_tailCtnQty') || '尾箱'"
            v-if="row.tailCtnQty"
            :contentStyle="{ color: 'red' }"
          >
            {{ row.tailCtnQty }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('table_label_totalCtnQty') || '总箱'"
            v-if="row.totalCtnQty"
          >
            {{ row.totalCtnQty }}
          </el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center" class="mt-2">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('tips_table_noSkuInv') || '该SKU无库存信息' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import { multiply, divideDown } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight],
  props: {
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
      editRules: {
        displayScm: [
          {
            validator: ({ row }) => {
              const { displayEcomWarehouseCode, qty } = row
              if (qty && !displayEcomWarehouseCode) {
                return new Error(this.$l('INDEX.tips_select_placeholder'))
              }
            },
          },
        ],
        displayFactory: [
          {
            validator: ({ row }) => {
              const {
                invoiceFactoryCode,
                shippingFactoryCode,
                factoryDate,
                qty,
              } = row
              if (
                qty &&
                (!invoiceFactoryCode || !shippingFactoryCode || !factoryDate)
              ) {
                return new Error(this.$l('INDEX.tips_select_placeholder'))
              }
            },
          },
        ],
        replyQty: [
          {
            validator: ({ row }) => {
              const { qty, maxReplyQty } = row
              if (qty > maxReplyQty) {
                return new Error(
                  this.$l('tips_outMaxReply') || '返答数量大于库存数量'
                )
              }
            },
          },
        ],
      },
    }
  },
  computed: {
    maxHeight() {
      const height = this.tableHeight - 250
      return height < 430 ? 430 : height
    },
  },
  methods: {
    rowClassName({ row }) {
      const { amzPurchaseCode } = row
      return amzPurchaseCode ? 'match-order' : 'no-match-order'
    },
    cellClassName({ column, row }) {
      const { property } = column
      const className = ['align-top', property]

      if (property === 'displayFactory') {
        const { invoiceFactoryCode, shippingFactoryCode, factoryDate } = row
        if (!invoiceFactoryCode) className.push('invoice-factory-isnull')
        if (!shippingFactoryCode) className.push('shipping-factory-isnull')
        if (!factoryDate) className.push('factory-date-isnull')
      }
      if (property === 'displayScm') {
        const { displayEcomWarehouseCode } = row
        if (!displayEcomWarehouseCode) className.push('display-warehouse-isnull')
      }
      return className.filter(Boolean).join(' ')
    },
    async editClosed({ row }) {
      const { qty, inCtnQty } = row

      const ctnQty = divideDown(qty, inCtnQty, 0)
      const tailQty = qty - multiply(inCtnQty, ctnQty)
      const tailCtnQty = tailQty ? 1 : 0
      row.ctnQty = ctnQty
      row.tailQty = tailQty
      row.tailCtnQty = tailCtnQty
      row.totalCtnQty = ctnQty + tailCtnQty

      this.$emit('change', await this.getTableData())
    },
    async reloadData(data) {
      await this.$refs.skuTable.reloadData(data)
      this.$emit('change', data)
    },
    async validate() {
      return !(await this.$refs.skuTable.validate(true))
    },
    async getTableData() {
      const data = await this.$refs.skuTable.getTableData()
      const tableData = data?.tableData || []
      return tableData.map((item) => {
        const { totalCtnQty, ...data } = item
        return { ...data, ctnQty: totalCtnQty }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-input__inner {
    padding-left: 10px;
  }
  .border-none .el-input__inner {
    border: none;
    padding: 0;
  }
  .col--edit .vxe-cell {
    padding: 7px 0;
  }
  .vxe-body--column.displayScm:not(.col--actived) .vxe-cell,
  .vxe-body--column.displayFactory:not(.col--actived) .vxe-cell,
  .vxe-body--column.replyQty:not(.col--actived) .vxe-cell {
    padding-top: 0;
    padding-bottom: 0;
  }
  .col--seq:not(.vxe-header--column) .vxe-cell {
    margin-top: 7px;
    padding-left: 4px;
    padding-right: 4px;
  }

  .vxe-body--column.displayFactory.col--valid-error.invoice-factory-isnull {
    .vxe-cell--valid {
      top: 35px;
    }
  }
  .vxe-body--column.displayFactory.col--valid-error:not(.invoice-factory-isnull).shipping-factory-isnull {
    .vxe-cell--valid {
      top: 70px;
    }
  }
  .vxe-body--column.displayFactory.col--valid-error:not(.invoice-factory-isnull, .shipping-factory-isnull).factory-date-isnull {
    .vxe-cell--valid {
      top: 105px;
    }
  }
  .vxe-body--column.displayFactory.col--valid-error:not(.invoice-factory-isnull, .shipping-factory-isnull, .factory-date-isnull) {
    .vxe-cell--valid {
      display: none;
    }
  }
  .vxe-table--body tbody .vxe-body--row:last-child {
    .vxe-body--column.displayFactory.col--valid-error:not(.invoice-factory-isnull, .shipping-factory-isnull).factory-date-isnull {
      .vxe-cell--valid {
        top: 40px;
      }
    }
  }
  .vxe-body--column.displayScm.col--valid-error.display-warehouse-isnull {
    .vxe-cell--valid {
      top: 20px;
    }
  }

  .vxe-body--column:not(.col--edit) {
    .el-descriptions-item__container {
      line-height: 27px;
      .el-descriptions-item__label:empty {
        display: none;
      }
      .el-descriptions-item__content {
        flex: 1;
      }
      .el-descriptions-item__label:not(.is-bordered-label) {
        margin-right: 5px;
      }
    }
  }

  .vxe-body--column.replyQty.col--valid-error {
    .vxe-cell--valid {
      top: 36px;
    }
  }

  .el-descriptions-item__container {
    .edit-descriptions-item {
      line-height: 27px;
    }
    .el-descriptions-item__label:empty {
      display: none;
    }
    .el-descriptions-item__content {
      flex: 1;
    }
    .el-descriptions-item__label:not(.is-bordered-label) {
      margin-right: 5px;
    }
  }

  .vxe-body--row.match-order {
    .vxe-body--column:not(.col--edit) {
      .el-descriptions-item__container {
        line-height: 1.5;
      }
    }
  }
  .vxe-body--row.no-match-order {
    .vxe-body--column {
      .el-descriptions-item__container {
        line-height: 1.5;
      }
    }
  }

  .el-input-number .el-input__inner {
    text-align: left;
  }
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  margin: 1px 0;
}
</style>
